module.exports = __webpack_public_path__ + "img/join_1.d84b04ad.jpg";